
import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore';
import './Print.css'
const DEFAULT_ROW = 51
class PrintReportStockBalanceValue extends Component {

  constructor(props){
    super(props)

    this.state = ({
      data:{dataFormat:[],data:[]},
      report_title:'กำลังดึงข้อมูล..',
      sum_cost:'0'
    })

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount() {
    this.loadData()
  }  

  loadData() {
    let {data} = this.state
    let that = this
    ReportStore.loadStockHasSubCatList(that.props.stockType, '', that.props.catId, that.props.subCatId, '', '', function(result) {
      data.data = result.data
      data.dataFormat = that.getPagination(result.data)
      that.setState({data:data,report_title:'ไม่พบข้อมูล',sum_cost:result.sum_cost})
    },()=>{
      that.setState({report_title:'เกิดข้อผิดพลาด'})
    })  
  }

  getPagination(data) {
    let newData = []
    let allData = []
    let checkRow = 0
    data.forEach(function(item,index) {
        if (checkRow<DEFAULT_ROW)
          checkRow++
          newData.push(item)

        if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
          allData.push(newData)
          checkRow = 0
          newData = []
        }
    })  
    
    return allData
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getCostPerRow(item) {
    let quantity = item.quantity
    let cost_per_unit = item.cost_per_unit
    let amount = 0
    quantity = (quantity===''||quantity===null||quantity===undefined||isNaN(quantity)?0:quantity)
    cost_per_unit = (cost_per_unit===''||cost_per_unit===null||cost_per_unit===undefined||isNaN(cost_per_unit)?0:cost_per_unit)
    amount = quantity*cost_per_unit
    return amount
  }

  renderRowData(data,_index) {
    if (data.length>0) {
      return(
        data.map((item, index) => {
          return(
            <tr key={index}>
              <td className='text-center'>{item.productcode}</td>
              <td className='text-left'><div style={{whiteSpace:'nowrap',width:'300px',overflow:'hidden',textOverflow:'ellipsis'}}>{item.description}</div></td>
              <td className='text-center'>{item.quantity}</td>
              <td className='text-center'>{item.unit}</td>
              <td className='text-right'>{this.getNumberFormat(item.cost_per_unit)}</td>
              <td className='text-right'>{this.getNumberFormat(this.getCostPerRow(item))}</td>
            </tr>
          )  
        })
      )
    } else {
      return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
    }
  }

  renderTable(data,index,length) {
    return(
        <table className='table table-print-report-product-balance'>
          <tbody>
            <tr>
              <td style={{width:"150px"}} className="text-center">รหัสสินค้า</td>
              <td style={{width:"300px"}} className="text-center">ชื่ออะไหล่</td>
              <td style={{width:"100px"}} className="text-center">จำนวน</td>
              <td style={{width:"100px"}} className="text-center">หน่วยนับ</td>
              <td style={{width:"100px"}} className="text-center">ต้นทุน/หน่วย</td>
              <td style={{width:"100px"}} className="text-center">ต้นทุนทั้งหมด</td>
            </tr>
            {this.renderRowData(data,index)}
            {index===length?
            <tr>
              <td colSpan={5} className='text-right'>ยอดรวมสุทธิ</td>
              <td className='text-right'>{this.getNumberFormat(this.state.sum_cost)}</td>
            </tr>:''}
          </tbody>
        </table>
    )
  }

  renderComponentPage(data,index,length) {
    return(  
        <div className='font-print' key={index}>
            <header className="text-center">
                <h2>{this.props.title}</h2>
            </header>
            <div>
                {this.renderTable(data,index,length)}
            </div>
        </div>
    )    
}

renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
}

  render(){
    let {data} = this.state
    if (data.data.length===0) {
      return(
        <div>
          <PrintPreview
            leftBarTitle={this.props.title}
          >
            {this.renderNoData()}
          </PrintPreview>
        </div>
      )
    } else {
      return(
        <div>
          <PrintPreview
            leftBarTitle={this.props.title}
          >
            {
              data.dataFormat.map((item,index) => {
                return(
                  this.renderComponentPage(item,index,data.dataFormat.length-1)
                )
              })
            }
          </PrintPreview>
        </div>
      )
    }
  }
}

PrintReportStockBalanceValue.defaultProps = {
  title: 'ตารางรายงานสต็อกมูลค่าคงเหลือ',
}

export default PrintReportStockBalanceValue;





// WEBPACK FOOTER //
// ./src/view/print/stock/PrintReportStockBalanceValue.js